// @flow
import modularui from "../_modularui/ModularUIConnector";

import type { ModularUIConnector } from "../_modularui/types";

/**
 * @deprecated - will be removed in the future, use the equivalent hook 'useConceptDetail' instead
 */
export const connectConceptDetail: ModularUIConnector = modularui(
  "ConceptDetail",
  ({ concept, location }) => `/concepts/${concept}${location.search}`,
  { propName: "conceptDetail" },
);
